import 'litepicker/dist/plugins/mobilefriendly'
import 'litepicker/dist/plugins/ranges'
import CalendarSettings from '../../Booking/frontend/js/CalendarSettings'
import FiltersProductSelect from './FiltersProductSelect'
import { BookingAjaxes } from '../../Booking/frontend/js/BookingAjaxes'
import { DateTime } from 'litepicker/dist/types/datetime'
import CalendarUtils from '../../calendar/CalendarUtils'

class FiltersDatepicker {
  form: HTMLFormElement
  datepicker?: any | undefined
  startDateInput?: HTMLInputElement
  endDateInput?: HTMLInputElement
  daysInput?: HTMLInputElement
  startDateInputHidden?: HTMLInputElement
  endDateInputHidden?: HTMLInputElement

  constructor(form: HTMLFormElement) {
    this.form = form
    this.startDateInput = this.form.querySelector('.js-cruise-datepicker-start') as HTMLInputElement
    this.endDateInput = this.form.querySelector('.js-cruise-datepicker-end') as HTMLInputElement
    this.daysInput = this.form.querySelector('.js-cruise-days-length') as HTMLInputElement

    this.startDateInputHidden = this.startDateInput
      .closest('label')
      ?.querySelector('input[type="hidden"]') as HTMLInputElement
    this.endDateInputHidden = this.endDateInput
      .closest('label')
      ?.querySelector('input[type="hidden"]') as HTMLInputElement
  }

  initDatePicker() {
    const bookingAjaxes = new BookingAjaxes()
    const calendarSettings = new CalendarSettings()

    const { startDateInput, endDateInput, daysInput } = this

    if (startDateInput && endDateInput && daysInput) {
      import('../../../lib/Litepicker/dist/litepicker.js').then(() => {
        const fltersProductSelect = new FiltersProductSelect(this.form)

        Promise.all([bookingAjaxes.getBookedDays(), bookingAjaxes.getDisabledDays()]).then(
          ([booked, disbaledDatesResponse]) => {
            this.datepicker = new Litepicker({
              element: startDateInput,
              elementEnd: endDateInput,
              lockDays: booked.dates,
              minRangelockDays: disbaledDatesResponse.dates,
              lang: calendarSettings.getLanguage(),
              singleMode: false,
              format: 'DD.MM.YYYY',
              inlineMode: false,
              numberOfMonths: 2,
              numberOfColumns: 2,
              disallowLockDaysInRange: true,
              showTooltip: false,
              plugins: ['mobilefriendly'],
              minDate: new Date(Date.now() - 86400000),
              minDays: 2,
              hotelType: true,
              setup: picker => {
                picker.on('before:click', (target: HTMLElement) => {
                  if (!target.classList.contains('cant-start-end') || !target.dataset.time) {
                    return
                  }

                  const dateStart = CalendarUtils.getEnabledDateBefore(
                    Litepicker.getDateTimeInstance(target.dataset.time),
                    booked.dates,
                    disbaledDatesResponse.dates,
                  )
                  const dateEnd = CalendarUtils.getEnabledDateAfter(
                    Litepicker.getDateTimeInstance(target.dataset.time),
                    booked.dates,
                    disbaledDatesResponse.dates,
                  )

                  picker.setDateRange(dateStart, dateEnd, true)
                  picker.hide()
                })

                picker.on('selected', (dateStart: DateTime, dateEnd: DateTime) => {
                  const { startDateInputHidden, endDateInputHidden, daysInput } = this

                  if (startDateInputHidden && endDateInputHidden && daysInput) {
                    startDateInputHidden.value = dateStart.format('YYYY-MM-DD')
                    endDateInputHidden.value = dateEnd.format('YYYY-MM-DD')

                    const days = dateEnd.diff(dateStart, 'day')
                    daysInput.value = `${days} ${
                      days === 1 ? daysInput.getAttribute('data-singular') : daysInput.getAttribute('data-plural')
                    }`

                    bookingAjaxes
                      .getAvailableBoatsForDates(dateStart.format('YYYY-MM-DD'), dateEnd.format('YYYY-MM-DD'))
                      .then((res: IAvailableBoatsForDates) => {
                        fltersProductSelect.setOptions(res)
                        endDateInputHidden.dispatchEvent(new Event('change'))
                      })
                  }
                })
              },
            })

            const clearButton = this.form.querySelector('.filters-clear-button') as HTMLButtonElement
            if (clearButton)
              clearButton.addEventListener('click', () => {
                this.datepicker?.clearSelection()
                this.clear()
              })

            daysInput.addEventListener('click', () => {
              this.datepicker?.show()
            })
          },
        )
      })
    }
  }

  private clear() {
    const { startDateInput, endDateInput, daysInput, datepicker, startDateInputHidden, endDateInputHidden } = this

    if (startDateInput && endDateInput && daysInput && startDateInputHidden && endDateInputHidden) {
      startDateInput.setAttribute('value', '')
      endDateInput.setAttribute('value', '')
      daysInput.setAttribute('value', '')
      startDateInputHidden.setAttribute('value', '')
      endDateInputHidden.setAttribute('value', '')
    }
  }
}

export default FiltersDatepicker
